<div class="confirmation-popup" *ngIf="data.cancelText && !data.title">
    <h2 mat-dialog-title >Confirmación</h2>
   
    <mat-dialog-content>
        <p>{{data.text}}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="mat-raised-button" (click)="cancel()" *ngIf="data.cancelText">{{ data.cancelText }}</button>
        <button class="mat-raised-button" (click)="confirm()">{{ data.confirmText }}</button>
    </mat-dialog-actions>
</div>


<div class="confirmation-popup" *ngIf="!data.cancelText">
    <h2 mat-dialog-title  style="color: #1F775A; font-weight: bold;">{{data.title}}</h2>
    <mat-dialog-content>
        <p>{{data.text}}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="mat-raised-button" (click)="cancel()" *ngIf="data.cancelText">{{ data.cancelText }}</button>
        <button class="mat-raised-button" (click)="confirm()" style="background-color: #1F775A;" >{{ data.confirmText }}</button>
    </mat-dialog-actions>
</div>

<div class="confirmation-popup1" *ngIf="data.cancelText && data.title">
    <h2 mat-dialog-title  style="color: #1F775A; font-weight: bold;">{{data.title}}</h2>
    <mat-dialog-content>
        <p>{{data.text}}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="mat-raised-button" (click)="cancel()" *ngIf="data.cancelText"><a href ='https://portal.xtensa.es/xtensaBasica' target="_parent">{{ data.cancelText }} </a></button>
        <button class="mat-raised-button" (click)="confirm()" style="background-color: #1F775A;" ><a href ='https://portal.xtensa.es' target="_parent">{{ data.confirmText }}</a></button>
    </mat-dialog-actions>
</div>

<!-- <div class="confirmation-popup" *ngIf="data.cancelText && data.title && data.title">
    <h2 mat-dialog-title  style="color: #1F775A; font-weight: bold;">{{data.title}}</h2>
    <mat-dialog-content>
        <p>{{data.text}}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="mat-raised-button" (click)="cancel()" *ngIf="data.cancelText">{{ data.cancelText }}</button>
        <button class="mat-raised-button"  style="background-color: #2f1f77;" > <a href ='https://portal.xtensa.es' target="_parent">{{ data.confirmText }}</a> </button> 
    </mat-dialog-actions>
</div> -->
